import util from '../utils/util';
import {debounce} from './custom-lodash';

/**
 * @description Initializes the site context
 */
function initSite() {
    const siteContext = window.bs_ssp_site_context;

    if (util.isMobile()) {
        siteContext.layout = 'mobile';
    } else if (util.isTablet()) {
        siteContext.layout = 'tablet';
    }

    window.ssp('set', 'site', siteContext);
}

/**
 * @param {string|null} billingEmail - billing email if the initialization occurs on the order confirmation page
 * @description Initializes the user context
 */
function initUser(billingEmail) {
    const userContext = $('#customerDataContainer').data('fit-predictor-user-context') || {};

    // Set billing email as user email in case of guest checkout
    if (!userContext.userId && billingEmail) {
        userContext.email = billingEmail;
    }

    window.ssp('set', 'user', userContext);
}

/**
 * @description Initializes analytics events
 */
function initAnalitycsEvents() {
    if (window.dataLayer) {
        window.ssp(
            'subscribe',
            'click',
            debounce(function (data) {
                // Track the "Calculate your size" click event
                if (data.state === 'cta') {
                    window.dataLayer.push({
                        event: 'fitPredictor_calculateSizeClick',
                        productId: data.productId
                    });
                }

                // Track popup dispay event
                window.dataLayer.push({
                    event: 'fitPredictor_popupDisplayed',
                    productId: data.productId
                });
            }),
            100
        );

        // Track the "Recommended size displayed" event
        window.ssp('subscribe', 'prediction', function (data) {
            window.dataLayer.push({
                event: 'fitPredictor_recommendedSizeDisplayed',
                productId: data.productId,
                size: data.size,
                sizeType: data.sizeType
            });
        });
    }
}

/**
 * @description Initializes all the contexts
 * @param {string} pageType type of the page being initialized
 * @param {object|null} orderData object containing order data in case of the order confirmation page being initialized
 */
export function init(pageType, orderData) {
    // check if fit predictor is enabled
    if (!window.ssp) {
        return;
    }

    initSite();

    window.ssp('set', 'page', {
        type: pageType
    });

    let billingEmail = null;
    if (orderData && orderData.email) {
        billingEmail = orderData.email;
    }

    initUser(billingEmail);
    initAnalitycsEvents();
}

/**
 * @description Renders the fit predictor widget
 */
export function start() {
    // check if fit predictor is enabled
    if (!window.ssp) {
        return;
    }

    window.ssp('start', 'fitpredictor');
}

/**
 * @description Renders the fit predictor widget
 */
export function setProduct() {
    // check if fit predictor is enabled
    if (!window.ssp) {
        return;
    }

    const productContext = $('.fp-root').data('product-context');

    if (productContext) {
        const region = $('.size-region .tab-selected').data('region');

        window.ssp('set', 'product', {
            ...productContext,
            sizeSystem: region,
            sizeConversion: `${productContext.gender}-${region}`
        });
    }
}

/**
 * @description Track the add to cart event
 */
export function trackAddToCart() {
    // check if fit predictor is enabled
    if (!window.ssp) {
        return;
    }

    const productData = {
        productId: $('#pdpMain').data('masterid'),
        quantity: 1,
        variantId: $('#pid').val()
    };

    window.ssp('track', 'addVariantToCart', productData);
}

/**
 * @description Track the ordered variants on the order confirmation page
 */
export function trackOrderVariants() {
    // check if fit predictor is enabled
    if (!window.ssp) {
        return;
    }

    $('.item-details[data-order-variant]').each(function () {
        const trackData = $(this).data('order-variant');

        if (trackData) {
            window.ssp('track', 'orderVariant', trackData);
        }
    });
}
